import { runDemo } from "../shared/demoRunner";
import { createParticles2Scene } from "./scene";

runDemo({ createScene: createParticles2Scene });
